import { Text, Stack } from '@mantine/core';
import { t } from 'i18next';

interface FormLabelProps {
  title: string;
  description: string;
  fullWidth?: boolean;
}

export const ConfigLabel = ({
  title,
  description,
  fullWidth,
}: FormLabelProps) => {
  return (
    <Stack spacing={0} sx={{ maxWidth: fullWidth ? undefined : 250 }}>
      <Text fz="sm" fw={500}>
        {t(title)}
      </Text>
      <Text c="dimmed" fz="xs">
        {t(description)}
      </Text>
    </Stack>
  );
};
